<script lang="ts">
    import { createEventDispatcher, onMount } from 'svelte'
    import { FormTemplateItemType as ItemType } from '../../../modules/toolsApi/forms/form-templates/form-template-item-type.enum'
    import ContentText from './static_text.svelte'
    import InputText from './input_text.svelte'
    import InputRadioCheck from './input_radio_check.svelte'
    import InputSign from './input_sign.svelte'
    import InputBeforeAfter from './input_before-after.svelte'
    import { FormData } from '../../../modules/toolsApi/forms/form-datas/form-data'
    import { FormDataContent } from '../../../modules/toolsApi/forms/form-datas/form-data-content'
    import { FormTemplate } from '../../../modules/toolsApi/forms/form-templates/form-template'

    import InputFitzpatrick from './input_fitzpatrick.svelte'
    import InputHairStroke from './input_hair_stroke.svelte'
    import InputTextFormated from './input_text_formated.svelte'
    import ImageGallery from './image-gallery.svelte'
    import { FormDataStatusEnum } from '../form-data-status.enum'
    import SharePageHeader from '../../_common/share-page-header.svelte'
    import SharePageFooter from '../../_common/share-page-footer.svelte'
    let dispatch = createEventDispatcher()

    export let company
    export let formData: FormData = new FormData()
    export let view: boolean = false
    export let isLink: boolean

    let appearence = 'default'
    let show: boolean = true

    $: {
        reassingFormData(formData.template)
    }

    onMount(() => {
        console.log('content', formData)
    })

    function prepareAndGetField(id) {
        let field = formData.template.form.find((el) => el.id === id)
        return field
    }

    let lastId = null
    let showSave = true
    function reassingFormData(f: FormTemplate) {
        if (!f || lastId === f.formTemplateId) return
        lastId = f.formTemplateId
        show = true
        if (f) {
            loadFormData()
            if (showSave && formData.status === FormDataStatusEnum.SIGNED) {
                showSave = false
            }
        } else {
            formData = new FormData()
            formData.content = []
            formData.template = new FormTemplate()
            formData.template.appearence = 'default'
            formData.template.paged = 0
        }
        appearence = formData.template.appearence || 'default'
        if (showSave && formData.template?.paged === 0) {
            formData.template.paged = formData.content.length
        }
        setTimeout(() => (show = false), 10)
    }

    function loadFormData() {
        console.log('load')
        if (formData.template?.form) {
            if (!formData.formDataId) {
                formData.content = []
            }
            for (const form of formData.template?.form) {
                if (!form) continue
                if (!formData.content) {
                    formData.content = []
                }
                if (!formData.content.find((el) => el.id === form.id)) {
                    let item: FormDataContent = new FormDataContent()
                    item.id = form.id
                    if (form.type === ItemType.before_after) {
                        item.value = { before: '', after: '' }
                    } else {
                        item.value = ''
                    }
                    item.type = form.type
                    formData.content.push(item)
                }
            }
        }
        setTimeout(() => (show = false), 100)
    }

    function elementOnChange() {
        dispatch('change')
    }

    function elementOnRemove() {
        dispatch('change')
    }
</script>

{#if !show}
    <div class="frms {appearence}" data-id="frms" id="frms">
        {#if formData.template?.showHeaders === true}
            <div class="h-print">
                <SharePageHeader {company} position="relative"></SharePageHeader>
            </div>
        {/if}
        {#each formData.content as content, index}
            {@const item = prepareAndGetField(content.id)}
            {#if item}
                <div data-id="i_{item.id}" id="i_{item.id}" class="frm">
                    {#if item.type === ItemType.label_formated}
                        <ContentText editable={false} {item} {formData}></ContentText>
                    {/if}
                    {#if item.type === ItemType.text_short}
                        <InputText
                            view={view || (isLink && item.locked)}
                            on:change={elementOnChange}
                            on:remove={elementOnRemove}
                            editable={false}
                            {item}
                            bind:value={content}
                            type="single"
                        ></InputText>
                    {/if}
                    {#if item.type === ItemType.text_long}
                        <InputText
                            view={view || (isLink && item.locked)}
                            on:change={elementOnChange}
                            on:remove={elementOnRemove}
                            editable={false}
                            {item}
                            bind:value={content}
                            type="multi"
                        ></InputText>
                    {/if}
                    {#if item.type === ItemType.date}
                        <InputText
                            view={view || (isLink && item.locked)}
                            on:change={elementOnChange}
                            on:remove={elementOnRemove}
                            editable={false}
                            {item}
                            bind:value={content}
                            type="date"
                        ></InputText>
                    {/if}
                    {#if item.type === ItemType.text_formated}
                        <InputTextFormated
                            view={view || (isLink && item.locked)}
                            on:change={elementOnChange}
                            on:remove={elementOnRemove}
                            editable={false}
                            {item}
                            bind:value={content}
                        ></InputTextFormated>
                    {/if}
                    {#if item.type === ItemType.choice_one}
                        <InputRadioCheck
                            view={view || (isLink && item.locked)}
                            on:change={elementOnChange}
                            on:remove={elementOnRemove}
                            editable={false}
                            {item}
                            bind:value={content}
                            multi={false}
                        ></InputRadioCheck>
                    {/if}
                    {#if item.type === ItemType.choice_multiple}
                        <InputRadioCheck
                            view={view || (isLink && item.locked)}
                            on:change={elementOnChange}
                            on:remove={elementOnRemove}
                            editable={false}
                            {item}
                            bind:value={content}
                            multi={true}
                        ></InputRadioCheck>
                    {/if}
                    {#if item.type === ItemType.sign}
                        <InputSign
                            view={view || (isLink && item.locked)}
                            on:change={elementOnChange}
                            on:remove={elementOnRemove}
                            editable={false}
                            {item}
                            bind:value={content}
                            metadata={formData.metadata}
                            hash={formData.hash}
                        ></InputSign>
                    {/if}
                    {#if item.type === ItemType.before_after}
                        <InputBeforeAfter
                            view={view || (isLink && item.locked)}
                            on:change={elementOnChange}
                            on:remove={elementOnRemove}
                            editable={false}
                            {item}
                            bind:value={content}
                        ></InputBeforeAfter>
                    {/if}
                    {#if item.type === ItemType.fitzpatrick}
                        <InputFitzpatrick
                            view={view || (isLink && item.locked)}
                            on:change={elementOnChange}
                            on:remove={elementOnRemove}
                            editable={false}
                            {item}
                            bind:value={content}
                        ></InputFitzpatrick>
                    {/if}
                    {#if item.type === ItemType.hair_stroke}
                        <InputHairStroke
                            view={view || (isLink && item.locked)}
                            on:change={elementOnChange}
                            on:remove={elementOnRemove}
                            editable={false}
                            {item}
                            bind:value={content}
                        ></InputHairStroke>
                    {/if}
                    {#if item.type === ItemType.image_gallery}
                        <ImageGallery
                            paint={false}
                            view={view || (isLink && item.locked)}
                            on:change={elementOnChange}
                            on:remove={elementOnRemove}
                            editable={false}
                            {item}
                            bind:value={content}
                        ></ImageGallery>
                    {/if}
                    {#if item.type === ItemType.image_paint}
                        <ImageGallery
                            paint={true}
                            view={view || (isLink && item.locked)}
                            on:change={elementOnChange}
                            on:remove={elementOnRemove}
                            editable={false}
                            {item}
                            bind:value={content}
                        ></ImageGallery>
                    {/if}
                </div>
            {/if}
        {/each}
        {#if formData.template?.showHeaders === true}
            <div class="h-print">
                <SharePageFooter {company} position="relative" createdAt={formData.createdAt}></SharePageFooter>
            </div>
        {/if}
    </div>
{/if}

<style>
    :global(.ql-toolbar) {
        background-color: white;
    }
    .editor {
        background-color: #ccc;
        color: black;
        height: 220px;
        font-size: 18px;
        overflow: auto !important;
        min-height: 220px;
    }
    .no-selection {
        user-select: none;
    }
    :global(.ql-editor) {
        max-width: unset;
        margin: 0px 0px;
        background-color: white;
        overflow: unset !important;
        height: unset !important;
        min-height: 1460px;
    }
    :global(.ql-editor ol, .ql-editor ul) {
        padding-left: 0px !important;
    }

    .field-background {
        background: #99999910;
        margin-top: 2px;
        margin-bottom: 2px;
    }

    @media (max-width: 900px) {
        .item-static button {
            margin-top: 6px !important;
            margin-bottom: 8px !important;
        }
    }
</style>
